import { render, staticRenderFns } from "./_stockroom.vue?vue&type=template&id=72e41d7e&"
import script from "./_stockroom.vue?vue&type=script&lang=js&"
export * from "./_stockroom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports